﻿<template>
    <section class="mb-card">
        <div class="mb-card-body">
            <h3 class="mb-card-title">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
                </svg>
                Your details
            </h3>
            <p class="mb-card-intro">The consultant details for your login.</p>

            <div class="mb-form-grid is-two">
                <div class="mb-field">
                    <label for="consultant_first_name">First name</label>
                    <input type="text" name="fname" id="consultant_first_name" spellcheck="false" autocomplete="given-name" v-model="selected_contact.first_name" class="mb-input" />
                </div>
                <div class="mb-field">
                    <label for="consultant_email">Email</label>
                    <input type="email" name="email" id="consultant_email" spellcheck="false" autocomplete="email" v-model="selected_contact.email" class="mb-input" />
                </div>
            </div>

            <div class="mb-form-actions">
                <button type="button" class="button" :disabled="saving_details" @click="Save_Details()">
                    <svg v-if="saving_details" class="mb-spinner" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" />
                        <path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
                    </svg>
                    {{ saving_details ? 'Saving…' : 'Save details' }}
                </button>
            </div>
        </div>
    </section>
</template>

<script lang="ts" src="./consultant_information.ts"></script>